var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "charity-property-inner border p-3" }, [
      _c("div", { staticClass: "row px-0 mx-0" }, [
        _c("div", { staticClass: "col-10 pl-0" }, [
          _c("div", { staticClass: "form-check mb-0" }, [
            _c("input", {
              staticClass: "form-check-input",
              attrs: {
                type: "checkbox",
                name: _vm.group ? _vm.group.id : "check" + _vm._uid,
                id: "check" + _vm._uid,
                "data-testing": "order-property-input-checkbox",
              },
              domProps: { value: _vm.property.id, checked: _vm.property.value },
              on: {
                change: function ($event) {
                  return _vm.onInputValueChanged($event.target.checked)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                staticClass: "form-check-label text-appearance d-flex",
                class: { "text-danger": _vm.hasError },
                attrs: {
                  for: "check" + _vm._uid,
                  "data-toggle": "tooltip",
                  title: _vm.charity.title
                    ? _vm.charity.title
                    : _vm.charity.name,
                },
              },
              [
                _c("strong", {
                  staticClass: "text-wrap ml-1",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.charity.title ? _vm.charity.title : _vm.charity.name
                    ),
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mt-1 ml-1" }, [
              _c("span", {
                staticClass: "text-wrap",
                domProps: { innerHTML: _vm._s(_vm.charityDonationText) },
              }),
              _c("br"),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "text-primary cursor-pointer d-inline-block mt-1",
                  on: {
                    click: function ($event) {
                      return _vm.toggleDescription()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                            " +
                      _vm._s(
                        _vm.$translate("GonserDT::Template.generalSeeMore")
                      ) +
                      "\n                        "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-2 align-self-center text-right px-0 px-sm-2" },
          [
            _c("img", {
              staticClass: "charity-img img-fluid",
              attrs: {
                src: "/documents/" + _vm.charity.image,
                alt: _vm.charity.name,
              },
            }),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "charityDescription", tabindex: "-1", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h3", {
                staticClass: "modal-title text-primary",
                attrs: { id: "charityDescriptionTitle" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.charity.title ? _vm.charity.title : _vm.charity.name
                  ),
                },
              }),
              _vm._v(" "),
              _vm._m(0),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", {
                staticClass: "text-wrap",
                domProps: { innerHTML: _vm._s(_vm.charity.shortDescription) },
              }),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close text-primary",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }